//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'vux'
import { mapState } from 'vuex'

import { service, nativeApi } from '@/common/index'
import { fetch } from '@/page/index'
import moment from 'moment'
import { Dialog, Toast } from 'vant'
import SrmCommonUtils from "@/utils/SrmCommonUtils"

export default {
  data () {
    return {
      value: '',
      headerId: this.$route.query.headerId,
      quote: {},
      time: 30000,
      baseUnits: [],
      taxList: [],
      taxColumns: [],
      taxIndex: 0,
      showTaxPicker: false,
      respondItemIndex: -1,
      // source 寻源单附件
      activeFujian: [''],
      showSource: false, // popup显示/隐藏
      sourceIds: '', // 文件ids
      sourceFileList: [], // 文件列表 用于展示
      // quote 报价附件
      showQuotation: false,
      quoteIds: '',
      quoteFileList: []
    }
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes
    }),
    noTaxPriceTotal: {
      get () {
        let total = 0
        if (this.quote == null || this.quote.respondItemVOList == null) {
          return total
        }
        this.quote.respondItemVOList.forEach((item) => {
          total += item.demandQuantity * item.noTaxPrice
        })
        return total
      },
      set () {}
    },
    checkTaxEditAble: {
      get () {
        return (
          this.quote.publishCommFlag == 'Y' &&
          this.quote.respondCommStatus == 'DRAFT' &&
          this.quote.allowModifyTaxFlag == 'Y'
        )
      },
      set () {}
    }
  },
  created () {
    //this.requestBaseUnit()
    this.requestDetail()
    //this.requestTaxList()
  },
  activated: function () {},
  methods: {
    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    },
    requestDetail () {
      fetch
        .mobileFindById({
          lan: this.languageCode,
          respondHeaderId: this.headerId,
          queryChildrenFlag: 'Y'
        })
        .then((res) => {
          if (res.status === 'S') {
            if (res.status === 'S') {
              this.quote = res.data
              if (this.quote.commEndDate) {
                const end = moment(this.quote.commEndDate).valueOf()
                const current = moment().valueOf()
                this.time = end - current
              }
              this.initFilds()
            }
          }
        })
    },
    /*requestTaxList () {
      this.taxList = this.dicCodes.filter((item) => {
        return item.lookupType == 'BASE_TAX_LIST'
      })
      this.taxColumns = this.taxList
        .sort((a, b) => a.meaning - b.meaning)
        .map((item) => {
          item.text = item.meaning
          return item
        })
    },*/
    countFinish () {
      console.log('finish')
      // todo: 结束后效果
    },
    inputNoTaxPrice (item) {
      item.noTaxPrice = this.checkFloat(item.noTaxPrice)
      // 更新含税单价
      this.updateWithTaxPrice(item)
    },
    // 取小数点后两位
    checkFloat (price) {
      let rel = price
      const point = String(price).indexOf('.') // 小数点
      if (point != -1) {
        rel = price.slice(0, point + 3)
      }
      return rel
    },
    // 更新含税单价
    updateWithTaxPrice (item) {
      const noTax = item.noTaxPrice // 不含税单价
      const taxCode = item.taxCode // 税率快码值
      const tax = this.getLookupValuesMeaning('BASE_TAX_LIST', taxCode)
      const withTax = noTax * (1 + tax / 100)
      item.taxPrice = withTax.toFixed(2)
    },
    // 点击税率cell
    onClickTax (item, index) {
      // 判断可否设置税率
      if (!this.checkTaxEditAble) {
        return
      }
      // 1、设置picker默认index
      const tax = item.taxCode
      this.taxIndex = this.taxColumns.findIndex((column) => {
        return column.lookupCode == tax
      })
      // 记录设置respondItemVOList的index
      this.respondItemIndex = index
      // 显示picker
      this.showTaxPicker = true
    },
    // picker确认选项
    onConfirmTax (val) {
      // todo：更新制定的vo
      this.quote.respondItemVOList[this.respondItemIndex].taxCode =
        val.lookupCode
      this.quote.respondItemVOList.splice(
        this.respondItemIndex,
        1,
        this.quote.respondItemVOList[0]
      )
      // 更新含税单价
      this.updateWithTaxPrice(this.quote.respondItemVOList[0])
      this.showTaxPicker = false
    },
    save () {
      this.quote.lan = this.languageCode
      const params = JSON.parse(JSON.stringify(this.quote))
      fetch.moblieSaveOrUpdate(params).then((res) => {
        if (res.status === 'S') {
          if (res.status === 'S') {
            this.requestDetail()
            Toast('报价单保存成功')
          }
        }
      })
    },
    submit () {
      this.quote.lan = this.languageCode
      const params = JSON.parse(JSON.stringify(this.quote))
      fetch.mobileDoSubmit(params).then((res) => {
        if (res.status === 'S') {
          if (res.status === 'S') {
            this.requestDetail()
            Toast('报价单提交成功')
          }
        }
      })
    },
    checkEditAble () {
      // !(
      //     this.quote.publishCommFlag == "Y" &&
      //     this.quote.respondCommStatus == "DRAFT" &&
      //     this.quote.allowModifyTaxFlag == "Y"
      //   )
      return (
        (this.quote.publishTechFlag == 'Y' &&
          this.quote.respondTechStatus == 'DRAFT') ||
        (this.quote.publishCommFlag == 'Y' &&
          this.quote.respondCommStatus == 'DRAFT')
      )
    },
    /**
     * 附件相关 start
     */
    // 获取头部信息后，初始化附件(寻源单、报价)列表
    initFilds () {
      // 寻源单附件
      this.sourceIds = JSON.parse(JSON.stringify(this.quote.sourcingFilds))
      if (this.sourceIds == null || this.sourceIds == '') return
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: this.sourceIds
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            this.sourceFileList = res.data.map((source) => {
              return {
                status: 'done',
                file: {
                  name: source.originalFileName
                },
                path: source.filePath,
                fileId: source.id,
                download: true
              }
            })
          }
        })
      // 报价附件
      this.quoteIds = JSON.parse(JSON.stringify(this.quote.quotationFilds))
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: this.quoteIds
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            this.quoteFileList = res.data.map((quotation) => {
              return {
                status: 'done',
                file: {
                  name: quotation.originalFileName
                },
                path: quotation.filePath,
                fileId: quotation.id,
                download: true
              }
            })
          }
        })
    },
    afterRead (type) {
      let doc // 找到最新添加的文件
      switch (type) {
        case 'source':
          doc = this.sourceFileList.find((item) => {
            return item.status == '' || item.status == null
          })
          break
        case 'quote':
          if (this.quoteFileList == null || this.quoteFileList == '') return
          doc = this.quoteFileList.find((item) => {
            return item.status == '' || item.status == null
          })
          break
        default:
          break
      }
      if (!doc) return
      doc.status = 'uploading' // 上传中。。。
      // 上传文件
      fetch
        .fileUpload({
          files: doc.file
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            // 上传完成
            const fujian = res.data[0]
            doc.status = 'done' // 上传完成
            doc.fileId = fujian.id // 记录后台返回的文件Id
            doc.download = false
            // 更新附件ids参数
            this.uploadIds(type)
          } else {
            // 上传失败，设置状态"上传失败"
            doc.status = 'failed'
          }
        })
    },
    uploadIds (type) {
      switch (type) {
        case 'source':
          if (this.sourceFileList == null || this.sourceFileList.length == 0) { return }
          this.sourceIds = this.sourceFileList
            .filter((file) => {
              return file.fileId != null && file.fileId != '' // 筛选有id的文件，即已上传成功的文件
            })
            .map((item) => {
              return item.fileId // 取id值
            })
            .toString() // 转字符串
          // 更新到quote
          this.quote.sourcingFilds =
            this.sourceIds == null ? '' : this.sourceIds
          break
        case 'quote':
          if (this.quoteFileList == null || this.quoteFileList.length == 0) { return }
          this.quoteIds = this.quoteFileList
            .filter((file) => {
              return file.fileId != null && file.fileId != '' // 筛选有id的文件，即已上传成功的文件
            })
            .map((item) => {
              return item.fileId // 取id值
            })
            .toString() // 转字符串
          // 更新到quote
          this.quote.quotationFilds =
            this.quoteIds == null ? '' : this.quoteIds
          break

        default:
          break
      }
    },
    // 下载文件
    download (file) {
      console.log(file)
      fetch
        .getFileUrl({
          id: file.fileId
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            Dialog.confirm({
              title: '附件下载',
              message: '是否确认下载附件?'
            })
              .then(() => {
                window.location.href = res.data
              })
              .catch(() => {})
          }
        })
    },
    // 删除文件
    deleteFujian (type, file) {
      Dialog.confirm({
        title: '附件删除',
        message: '是否确认删除附件?'
      })
        .then(() => {
          switch (type) {
            case 'source':
              const srcIndex = this.sourceFileList.findIndex((item) => {
                return (item.fileId = file.fileId)
              })
              this.sourceFileList.splice(srcIndex, 1)
              break
            case 'quote':
              const quoIndex = this.quoteFileList.findIndex((item) => {
                return (item.fileId = file.fileId)
              })
              this.quoteFileList.splice(quoIndex, 1)
              break

            default:
              break
          }
          this.uploadIds(type)
        })
        .catch(() => {})
    },
    /**
     * 弃用
     */
    afterDelete (type) {
      this.uploadIds(type)
    },
    clickPreview (file) {
      fetch
        .getFileUrl({
          id: file.id
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            Dialog.confirm({
              title: '附件下载',
              message: '是否确认下载附件?'
            })
              .then(() => {
                window.location.href = res.data
              })
              .catch(() => {})
          }
        })
    },
    submitfujian (type) {
      switch (type) {
        case 'source':
          this.quote.sourcingFilds =
            this.sourceIds == null ? '' : this.sourceIds
          this.showSource = false
          break
        case 'quote':
          this.quote.quotationFilds =
            this.quoteIds == null ? '' : this.quoteIds
          this.showQuotation = false
          break

        default:
          break
      }
    },
    onClickfujian (type) {
      let ids = ''
      switch (type) {
        case 'source':
          this.sourceIds = JSON.parse(JSON.stringify(this.quote.sourcingFilds))
          ids = this.sourceIds
          this.showSource = true
          break
        case 'quote':
          this.quoteIds = JSON.parse(JSON.stringify(this.quote.quotationFilds))
          ids = this.quoteIds
          this.showQuotation = true
          break
      }
      if (ids == null || ids == '') {
        return
      }
      fetch
        .listBaseFile({
          lan: this.languageCode,
          ids: ids
        })
        .then((res) => {
          if (res.status === 'S' && res.status === 'S') {
            const fileList = res.data.map((source) => {
              return {
                status: 'done',
                file: {
                  name: source.originalFileName
                },
                path: source.filePath,
                fileId: source.id,
                download: true
              }
            })
            switch (type) {
              case 'source':
                this.sourceFileList = fileList
                break
              case 'quote':
                this.quoteFileList = fileList
                break
            }
          }
        })
    }

    /**
     * 附件相关 start
     */
  },
  filters: {
    fileNum (ids) {
      if (ids == null || ids.length == 0) return '无'
      const list = ids.split(',')
      return list.length + '个'
    }
  },
  watch: {},
  mounted () {}
}



// WEBPACK FOOTER //
// ./src/page/srm/quote/quote.vue